/**
 * Serviço de Domínio para consulta de GDE / GHE associados a um Produto
 */
export function formatGheStatus(status) {
    if (status === null || status === undefined) return "NÃO";
    if (typeof status === "boolean") return status ? "SIM" : "NÃO";
    if (typeof status === "number") return status === 1 ? "SIM" : "NÃO";

    const str = String(status).trim().toUpperCase();
    if (["SIM", "S", "TRUE", "1", "HABILITADO", "ATIVO"].includes(str)) {
        return "SIM";
    }
    return "NÃO";
}

export function isStatusHabilitado(status) {
    return formatGheStatus(status) === "SIM";
}

/**
 * Busca a relação de GDE/GHE para um determinado produto
 * @param {object} api - Instância do useApi
 * @param {string|number} productId - ID do produto
 * @returns {Promise<Array<{ nome: string, status: string, isHabilitado: boolean }>>}
 */
export async function fetchProdutoGheList(api, productId) {
    if (!productId) return [];

    try {
        const response = await api.get(`GrupoGestor/product/${productId}`);
        const rawData = response?.data;

        let items = [];
        if (Array.isArray(rawData)) {
            items = rawData;
        } else if (Array.isArray(rawData?.records)) {
            items = rawData.records;
        } else if (Array.isArray(rawData?.data)) {
            items = rawData.data;
        } else if (rawData && typeof rawData === "object") {
            items = [rawData];
        }

        return items.map((item, index) => {
            const rawStatus = item.status ?? item.habilitado ?? item.ativo;
            const statusLabel = formatGheStatus(rawStatus);
            const rawQtde = item.qtde ?? item.Qtde ?? item.quantidade ?? item.qtd;
            const rawPeriodic = item.periodic ?? item.Periodic ?? item.periodicidade;
            const groupId = item.groupId ?? item.grupoid ?? item.groupid ?? item.id;

            return {
                id: item.id ?? groupId ?? index,
                groupId: groupId,
                grupoid: groupId,
                groupid: groupId,
                nome: item.nome ?? item.grupogestor_nome ?? item.descricao ?? "-",
                qtde: rawQtde !== undefined && rawQtde !== null && !isNaN(rawQtde) ? Number(rawQtde) : 1,
                periodic: rawPeriodic !== undefined && rawPeriodic !== null && !isNaN(rawPeriodic) ? Number(rawPeriodic) : 90,
                status: statusLabel,
                isHabilitado: statusLabel === "SIM"
            };
        });
    } catch (error) {
        console.error(`Erro ao carregar GHE para o produto ${productId}:`, error);
        throw error;
    }
}

/**
 * Adiciona/Vincula o produto ao Grupo Gestor via POST
 * @param {object} api - Instância do useApi
 * @param {{ grupoid: number|string, prodid: number|string, qtde: number, periodic: number }} params
 */
export async function adicionarProdutoAoGrupo(api, { grupoid, prodid, qtde, periodic }) {
    try {
        const payload = {
            grupoid: parseInt(grupoid, 10),
            prodid: parseInt(prodid, 10),
            qtde: parseInt(qtde, 10) || 1,
            periodic: parseInt(periodic, 10) || 90
        };
        const response = await api.post("grupogestor/add/produto", payload);
        return { success: true, data: response?.data };
    } catch (error) {
        console.error("Erro ao adicionar produto ao grupo:", error);
        throw error;
    }
}

/**
 * Remove/Desvincula o produto do Grupo Gestor via DELETE
 * @param {object} api - Instância do useApi
 * @param {{ groupid: number|string, prodid: number|string }} params
 */
export async function removerProdutoDoGrupo(api, { groupid, prodid }) {
    try {
        const response = await api.delete(`GrupoGestor?groupid=${groupid}&prods=${prodid}`);
        return { success: true, data: response?.data };
    } catch (error) {
        console.error("Erro ao remover produto do grupo:", error);
        throw error;
    }
}

